import type { PageTour } from '../types';

export const surveysTour: PageTour = {
  id: 'surveys',
  label: 'Surveys Tour',
  steps: [
    {
      target: '[data-tour="surveys-header"]',
      title: 'Surveys',
      content: 'Create and manage surveys to gather feedback from your team or organization.',
    },
    {
      target: '[data-tour="surveys-create"]',
      title: 'Create a Survey',
      content: 'Click here to design a new survey. Add questions, set deadlines, and choose your audience.',
    },
    {
      target: '[data-tour="surveys-stats"]',
      title: 'Survey Statistics',
      content: 'See response rates and completion metrics for your active surveys at a glance.',
    },
    {
      target: '[data-tour="surveys-list"]',
      title: 'Survey List',
      content: 'View all surveys — active, draft, and completed. Click any survey to see results or edit it.',
    },
  ],
};
